;(function($, undefined){
    'use strict';

    var rnn = window.rnn;

    function initArticle() {
        $('.newsEntryBody .relatedContentTrigger').click(function() {
            var $theTrigger = $(this);

            $theTrigger.toggleClass('hideItems');

            if($theTrigger.hasClass('hideItems')){
                $theTrigger.html('Show Less <i class="icon9x9-collapseup-icon"></i>');
                $('li.hiddenItem').each(function() {
                    $(this).removeClass('toggleMoreItems');
                });
                $('.newsEntryBody ul li.hiddenItem').slideDown('slow', function() {
                    // animation finished
                });
            }else{
                $theTrigger.html('Show More <i class="icon9x9-dropdown-icon"></i>');
                $('li.hiddenItem').each(function() {
                    $(this).addClass('toggleMoreItems');
                });
                $('.newsEntryBody ul li.hiddenItem').slideUp('slow', function() {
                    // animation finished
                });
            }
        });

        var $articleParas = $('.newsEntryBody .story-body > p');

        if ($articleParas.length > 3) {
            var $related = $('.newsEntryBody .relatedcontent'),
                $space = $articleParas.eq(2),
                $adFragment = $('.mobileAd1Fragment');

            if ($related.length > 0) {
                $related.insertAfter($space);
                $space = $related;
            }

            if ($adFragment.length > 0) {
                $adFragment.detach().removeClass('hidden').insertAfter($space);
            }
        }

        // resize .nca-slider content coming from CAPI to fit into article's main column
        var columnWidth = 584;

        function resize() {
            if($('.nca-slider-slide').length > 0) {
                // found the image. Resize it...
                var ratio = columnWidth/$('.nca-slider').css('width').replace("px", "");
                var height = $('.nca-slider').css('height').replace("px", "");
                var adjustedHeight = (height * ratio) + "px";
                $('.nca-slider').css('height', adjustedHeight).css('width', "100%").find('.nca-slider-slide').css('width', "100%").css('height', adjustedHeight);
                // ...and switch off the timer
                clearInterval(resizeInterval);
            }
        }
        // since we don't have access to the JS that loads the slide/image we don't have the onloaded callback. We have to poll the page to see if the image has loaded.
        var resizeInterval = setInterval(resize, 250);

    }

    rnn.modules.register('article', {
        init: initArticle
    });

})(jQuery);